// extracted by mini-css-extract-plugin
module.exports = {"base":"src-components-common-___Loader__base___1wLzV","loader":"src-components-common-___Loader__loader___25gTH"};